// extracted by mini-css-extract-plugin
export default {"wrapper":"sms_wrapper__eGH5-"};